import { useState, useEffect, useCallback } from 'react';
import offlineQueue from '../utils/offlineQueue';

export const useOfflineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);
  const [isSyncing, setIsSyncing] = useState(false);

  useEffect(() => {
    // Initialize the queue
    offlineQueue.init().then(() => {
      offlineQueue.updatePendingCount();
    });

    // Subscribe to updates
    const unsubscribe = offlineQueue.subscribe(({ isOnline, pendingCount }) => {
      setIsOnline(isOnline);
      setPendingCount(pendingCount);
    });

    return () => unsubscribe();
  }, []);

  const syncNow = useCallback(async () => {
    if (!isOnline || isSyncing) return null;
    
    setIsSyncing(true);
    try {
      const result = await offlineQueue.syncPendingSales();
      return result;
    } finally {
      setIsSyncing(false);
    }
  }, [isOnline, isSyncing]);

  const queueSale = useCallback(async (sale) => {
    return await offlineQueue.queueSale(sale);
  }, []);

  const getPendingSales = useCallback(async () => {
    return await offlineQueue.getPendingSales();
  }, []);

  const clearSynced = useCallback(async () => {
    return await offlineQueue.clearSyncedSales();
  }, []);

  return {
    isOnline,
    pendingCount,
    isSyncing,
    syncNow,
    queueSale,
    getPendingSales,
    clearSynced
  };
};
